module Tapas.ViewModels {
    export class NewsletterSignupViewModel extends Ftw.ViewModels.BaseViewModel {
        public Email = ko.observable('');
        public FormState = ko.observable(0);
        public mvm: Elma.ViewModels.MasterViewModel = Ftw.Base.Config.MasterViewModel as Elma.ViewModels.MasterViewModel;
        //0 = idle
        //1 = in progress
        //2 = success
        //3 = error
        constructor(data) {
            super();
            this.InterceptSubmit();
        }

        public InterceptSubmit = () => {
            $('.js-newsletter-signup form').submit((e) => {
                e.preventDefault();
                if (this.FormState() != 1) {
                    this.FormState(1);
                    this.mvm.load().active(true);

                    var data = $(e.target).serialize();
                    //@ts-ignore
                    var action = e.target.action;

                    $.post(action, data)
                        .done((response) => {
                            this.FormState(2);
                            this.Email('');
                        })
                        .fail(() => {
                            this.FormState(3);
                        })
                        .always(() => {
                            this.mvm.load().active(false);
                        });
                }
            });

        }

    }
}